import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const IconMenuOrder = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M16.2 0H1.8C0.9 0 0 0.81 0 1.8V4.509C0 5.157 0.387 5.715 0.9 6.03V16.2C0.9 17.19 1.89 18 2.7 18H15.3C16.11 18 17.1 17.19 17.1 16.2V6.03C17.613 5.715 18 5.157 18 4.509V1.8C18 0.81 17.1 0 16.2 0ZM15.3 16.2H2.7V6.3H15.3V16.2ZM16.2 4.5H1.8V1.8H16.2V4.5Z" fill="#AEB4BE" />
            <path d="M11.7 9H6.3V10.8H11.7V9Z" fill="#AEB4BE" />
        </SvgIcon>
    );
};